import {
  PageBlueprint,
  createFrontendFeatureLoader,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';

export const securityV2Page = PageBlueprint.make({
  name: 'security-v2',
  params: {
    path: '/security-v2',
    title: 'Security v2',
    loader: async () =>
      import('./SecurityV2Page').then(module => <module.SecurityV2Page />),
  },
});

export const securityV2ServicePage = PageBlueprint.make({
  name: 'security-v2-service',
  params: {
    path: '/security-v2/services/:serviceId',
    title: 'Security v2 service',
    loader: async () =>
      import('./SecurityV2Page').then(module => <module.SecurityV2Page />),
  },
});

export const anderSecurityV2Module = createFrontendModule({
  pluginId: 'app',
  extensions: [securityV2Page, securityV2ServicePage],
});

export const anderSecurityV2FeatureLoader = createFrontendFeatureLoader({
  loader: ({ config }) =>
    config.getOptionalBoolean('app.securityV2Enabled') === true
      ? [anderSecurityV2Module]
      : [],
});
